import { Component, OnInit, Inject } from '@angular/core';
import { Common, _, core } from '@icc/shared/helpers';
import { WindowActiveConfiguration } from '@icc/window-door/types';
import { ConfigurationsService, DrawService, PageComponent } from '@icc/configurator/shared';
import { APP_CONFIG, AppConfigFactory, EventBusService, TranslateService } from '@icc/shared';
import { FillingsService } from '../modules/glazings/fillings.service';
import { BrowserGlazingBeadsService } from '../modules/glazings/glazing-beads.service';

@Component({
    selector: 'icc-glazing-layout-page',
    templateUrl: './glazing-layout-page.component.html',
    styleUrls: ['./glazing-layout-page.component.scss'],
    standalone: false
})
export class GlazingLayoutPageComponent extends PageComponent implements OnInit {
    title = _('WINDOW|Edycja konstrukcji');
    fullscreen = true;

    drawOptions: any = null;
    drawButtons = {
        fullscreen: false,
        moveShift: true,
        alignments: true,
        dimensions: false,
        extensions: true,
        mullions: true,
        profiles: false,
        sashes: true,

        toggle: (
            type:
                | 'alignments'
                | 'dimensions'
                | 'extensions'
                | 'fullscreen'
                | 'mullions'
                | 'profiles'
                | 'sashes'
        ) => {
            if (type && typeof this.drawButtons[type] !== 'undefined') {
                this.drawButtons[type] = !this.drawButtons[type];
            }

            this.drawButtons.update();
        },

        update: () => {
            const conf = this.configurationsService.conf.Current;
            if (conf) {
                this.drawOptions = Object.assign({}, this.drawService.options, {
                    glazing: {
                        buttons: [
                            {
                                innerHtml: `<img src="/application/dist/web/img/icons/gr_glazzing.png">`,
                                title: this.translateService.instant('WINDOW|Wybierz szklenie'),
                                onClick: (response: any) => {
                                    if (Common.isDefined(response.sash.parentId)) {
                                        const sash = core.fIdO(
                                            this.configurationsService.conf.Current.Sashes,
                                            response.sash.parentId
                                        );
                                        if (sash) {
                                            const intSash = core.fIdO(
                                                sash.intSashes,
                                                response.sash.id
                                            );
                                            this.fillingsService.openModal(
                                                intSash,
                                                this.configurationsService.conf.Current,
                                                this.configurationsService.conf.Default,
                                                sash
                                            );
                                        }
                                    } else {
                                        const sash = core.fIdO(
                                            this.configurationsService.conf.Current.Sashes,
                                            response.sash.id
                                        );
                                        this.fillingsService.openModal(
                                            sash,
                                            this.configurationsService.conf.Current,
                                            this.configurationsService.conf.Default,
                                            sash
                                        );
                                    }
                                },
                            },
                            {
                                condition: () =>
                                    (!this.configurationsService.conf.Current.OneGlazing
                                        || this.config().IccConfig.Configurators
                                            .glazingBeadsSelectSash)
                                    && this.config().IccConfig.Configurators.glazingBeadsSelect,
                                innerHtml: `<img src="/application/dist/web/img/icons/gr_glazzing2.png">`,
                                title: this.translateService.instant(
                                    'WINDOW|Wybierz listwę przyszybową'
                                ),
                                onClick: (response: any) => {
                                    if (Common.isDefined(response.sash.parentId)) {
                                        const sash = core.fIdO(
                                            this.configurationsService.conf.Current.Sashes,
                                            response.sash.parentId
                                        );
                                        if (sash) {
                                            const intSash = core.fIdO(
                                                sash.intSashes,
                                                response.sash.id
                                            );
                                            this.glazingBeadsService.openModalGlazingBead(
                                                this.configurationsService.conf.Current,
                                                intSash,
                                                sash
                                            );
                                        }
                                    } else {
                                        const sash = core.fIdO(
                                            this.configurationsService.conf.Current.Sashes,
                                            response.sash.id
                                        );
                                        this.glazingBeadsService.openModalGlazingBead(
                                            this.configurationsService.conf.Current,
                                            sash,
                                            sash
                                        );
                                    }
                                },
                            },
                        ],
                    },
                    onInterfaceClick: () => {},
                });
                this.drawOptions.base.side = 'inner';
            }

            this.eventBusService.post({
                key: 'icc-redraw',
                value: null,
            });
        },
    };

    constructor(
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private eventBusService: EventBusService,
        private configurationsService: ConfigurationsService<'window'>,
        public drawService: DrawService,
        private translateService: TranslateService,
        private glazingBeadsService: BrowserGlazingBeadsService,
        private fillingsService: FillingsService
    ) {
        super();
    }

    ngOnInit() {
        this.drawButtons.update();
    }
}
